import { Button, Card, FormButtonRow, Text } from '@ksyos/design-system';
import type { EpisodeCategory } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { getMedicalProtocolUrl, isMedicalProtocolAvailable } from '@frontend/utils/medicalProtocolAvailability';

export type MedicalProtocolProps = Readonly<{
    episodeCategoryName: EpisodeCategory;
}>;

export function MedicalProtocol({ episodeCategoryName }: MedicalProtocolProps): JSX.Element | null {
    const translate = getSelectedLanguage();

    if (!isMedicalProtocolAvailable(episodeCategoryName)) {
        return null;
    }

    const protocolUrl = getMedicalProtocolUrl(episodeCategoryName);
    if (!protocolUrl) {
        return null;
    }

    return (
        <Card>
            <Card.Header title={translate.common.medicalProtocol} />
            <Card.Body>
                <Text>
                    Om de kwaliteit en veiligheid van zorg te waarborgen, hanteren wij vastgestelde medische
                    protocollen. Deze protocollen zijn leidend voor de formulieren die je invult en bieden een klinische
                    basis.
                    <br />
                    <br />
                    Voor volledige richtlijnen verwijzen we je naar de protocollenpagina. Deze pagina opent in een nieuw
                    tabblad.
                </Text>
                <FormButtonRow>
                    <Button
                        iconRight="external"
                        onClick={() => {
                            window.open(protocolUrl, '_blank');
                        }}
                        variant="outline"
                    >
                        {translate.common.viewProtocol}
                    </Button>
                </FormButtonRow>
            </Card.Body>
        </Card>
    );
}
